import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';
import { withStyles, WithStyles } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles';
import { compose } from 'recompose';
import FieldLabel from './FieldLabel';
import { DatePicker } from 'material-ui-pickers';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Event from '@material-ui/icons/Event';
import moment from 'moment';
import Translator from './Translator';

type CssClasses = 'inputStyle' | 'fullWidth';
const styles: StyleRules<CssClasses> = {
  inputStyle: {
    backgroundColor: '#d6d6d6',
    border: 'solid 1px rgb(187, 187, 187)',

    fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
    fontSize: '15px',
    color: 'rgb(78, 78, 78)',
    fontWeight: 400,
    '&>*': {
      paddingTop: '10px',
      paddingBottom: '10px',
      paddingLeft: '10px',
      paddingRight: '8px',
      '&::before': {
        borderBottom: '0px !important',
      },
      fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
      fontSize: '15px',
      color: 'rgb(78, 78, 78)',
    },
  },
  fullWidth: {
    width: '100%',
  },
};

const INVALID = 'INVALID';

interface OwnProps {
  label?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  formControlClassName?: string;
  directError?: boolean;
  requireMark?: boolean;
  inputWidth?: string;
  containerWidth?: string;
  toolTipHtml?: string;
}

type Props = OwnProps & WrappedFieldProps;

class FormDateField extends React.PureComponent<Props & WithStyles<CssClasses>> {
  render() {
    const {
      meta,
      label,
      disabled,
      directError,
      classes,
      requireMark,
      fullWidth,
      inputWidth,
      containerWidth,
      input,
      toolTipHtml,
    } = this.props;
    const { error, touched, dirty, invalid } = meta;
    const inErrorState = invalid && (touched || dirty || directError);
    const width = fullWidth ? classes.fullWidth : null;
    const style = inputWidth != null ? { width: inputWidth } : {};
    const styleContainer = containerWidth != null ? { width: containerWidth } : {};

    const value = input.value;

    let parsedValue: Date | null = null;
    if (value != null && value !== INVALID) {
      const m = moment(value);
      if (m.isValid()) {
        parsedValue = m.toDate();
      }
    }

    return (
      <div style={styleContainer}>
        {label && (
          <FieldLabel
            text={label}
            required={requireMark}
            errorText={error}
            error={inErrorState}
            toolTipHtml={toolTipHtml}
          />
        )}
        <div>
          <Translator>
            {translate => (
              <DatePicker
                className={classes.inputStyle}
                keyboard
                format="DD.MM.YYYY"
                placeholder="__.__.____"
                // handle clearing outside => pass plain array if you are not controlling value outside
                mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]}
                clearable
                value={parsedValue}
                keyboardIcon={<Event />}
                leftArrowIcon={<ChevronLeft />}
                rightArrowIcon={<ChevronRight />}
                disableOpenOnEnter
                animateYearScrolling={false}
                onChange={this.handleChange}
                onError={this.handleError}
                invalidDateMessage={translate('invalidDate')}
                cancelLabel={translate('cancel')}
                clearLabel={translate('clear')}
              />
            )}
          </Translator>
        </div>
      </div>
    );
  }
  private handleError = () => {
    // window.console.log('CHANGING TO', INVALID);
    this.props.input.onChange(INVALID);
  };

  private handleChange = (date: moment.Moment | null) => {
    let stringValue: string | null;
    if (date == null) {
      stringValue = null;
    } else {
      if (date.isValid()) {
        stringValue = date.format('YYYY-MM-DD');
      } else {
        stringValue = INVALID;
      }
    }

    // window.console.log('CHANGING TO', stringValue);
    this.props.input.onChange(stringValue);
  };
}

export default compose<Props & WithStyles<CssClasses>, Props>(withStyles(styles))(FormDateField);



// WEBPACK FOOTER //
// ./src/components/FormDateField.tsx